// Significados de assinatura (seleção fechada — Parte 14.2).
// SIGNATURE_MEANINGS é o conjunto do seletor genérico de aprovação (Aprovação/Revisão/Autoria/Responsável);
// DELEGATION_SIGNATURE_MEANINGS são os do delegation log (REQ-AUTHZ-008; GIY-072): o PI "delega" e a pessoa "aceita" —
// fixados pelo servidor em cada rota, só exibidos aqui (nunca oferecidos no seletor genérico).
export const SIGNATURE_MEANINGS = ['Approved', 'Reviewed', 'Authored', 'Responsible'] as const;
export const DELEGATION_SIGNATURE_MEANINGS = ['Delegate', 'Accept'] as const;
export type SignatureMeaning =
  (typeof SIGNATURE_MEANINGS)[number] | (typeof DELEGATION_SIGNATURE_MEANINGS)[number];
